<script setup lang="ts">
defineProps<{
  text: string
  size?: 'xl' | 'lg' | 'md'
  align?: 'left' | 'center' | 'right'
  customClass?: string
}>()
</script>

<template>
  <div
    v-if="text"
    class="flex flex-row"
    :class="[
      align === 'center' ? 'text-center' : '',
      align === 'right' ? 'text-right' : '',
      customClass,
    ]"
  >
    <h1
      class="w-full"
      :class="{
        'text-5xl': size === 'xl',
        'text-4xl': size === 'lg' || !size,
        'text-xl': size === 'md',
      }"
    >
      {{ text }}
    </h1>
  </div>
</template>
